import styled from "styled-components";
import { Link } from "react-router-dom";

const Recommends = (props) => {
  const recommends = props.data;
  const type = props.type;

  return (
    <Container>
      <h4>Recommnded for You</h4>
      <Content>
        {recommends?.map((item) => {
          return (
            <Wrap key={item.id}>
              <Link to={`/detail/${type}/${item.id}`} reloadDocument>
                <img
                  src={`https://image.tmdb.org/t/p/w300/${item.backdrop_path}`}
                  alt=""
                />
                <span>{item.name || item.title}</span>
              </Link>
            </Wrap>
          );
        })}
      </Content>
    </Container>
  );
};

const Container = styled.div`
  padding: 0 0 26px;
`;
const Content = styled.div`
  display: grid;
  gap: 25px;
  grid-template-columns: repeat(4, minmax(0, 1fr));

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

const Wrap = styled.div`
  padding-top: 56.25%;
  border-radius: 10px;
  box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
    rgb(0 0 0 / 73%) 0px 16px 10px -10px;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
  border: 3px solid rgba(249, 249, 249, 0.1);

  img {
    inset: 0px;
    display: block;
    height: 100%;
    object-fit: cover;
    filter: opacity(0.8);
    position: absolute;
    transition: opacity 500ms ease-in-out 0s;
    width: 100%;
    z-index: 1;
    top: 0;

    &:hover {
      filter: opacity(1);
    }
  }

  &:hover {
    box-shadow: rgb(0 0 0 / 80%) 0px 40px 58px -16px,
      rgb(0 0 0 / 72%) 0px 30px 22px -10px;
    transform: scale(1.05);
    border-color: rgba(249, 249, 249, 0.8);
  }

  span {
    z-index: 3;
    font-size: 15px;
    letter-spacing: 1.02px;
    position: absolute;
    margin-left: 2px;
    bottom: 2px;
    left: 2px;
    right: 2px;
  }
`;

export default Recommends;
